import { render, staticRenderFns } from "./BlogCard.vue?vue&type=template&id=1af368d2&scoped=true&"
import script from "./BlogCard.vue?vue&type=script&lang=js&"
export * from "./BlogCard.vue?vue&type=script&lang=js&"
import style0 from "./BlogCard.vue?vue&type=style&index=0&id=1af368d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af368d2",
  null
  
)

export default component.exports